import { useCallback, useEffect, useState } from 'react'
import gql from 'graphql-tag'
import { debounce } from 'lodash'
import {
  ActivityFilter,
  ActivityStatus,
  JobType,
  useGqlFilterSubmitButtonActivitiesLazyQuery,
} from 'generated/graphql'
import { ActivityTypeID } from 'constants/enums'
import useActivityFilterStore from '../../../store/storeActivityFilter'

gql`
  query gqlFilterSubmitButtonActivities(
    $filterBy: ActivityFilter
    $rangeBy: ActivityRange
  ) {
    activities(
      filterBy: $filterBy
      rangeBy: $rangeBy
      pagination: { page: 1, pageSize: 1 }
    ) {
      totalCount
    }
  }
`

const getFirstAndLastDayTimestamps = () => {
  const currentDate = new Date() // 현재 날짜를 가져옴
  const [fullYear, month] = [currentDate.getFullYear(), currentDate.getMonth()]
  const firstDay = Math.floor(new Date(fullYear, month, 1).getTime())
  const lastDay = Math.floor(new Date(fullYear, month + 1, 0).getTime())
  return {
    firstDay,
    lastDay,
  }
}

export const useFilterSubmitButton = (filterType: 'calender' | 'activity') => {
  const [filterBy, setFilterBy] = useState<ActivityFilter>()
  const [keywordDebounce, setKeywordDebounce] = useState<boolean>(false)
  const { selectedFilter, keyword, getFilterBy } = useActivityFilterStore()

  const [fetch, { data, loading }] =
    useGqlFilterSubmitButtonActivitiesLazyQuery()

  const timestamps = getFirstAndLastDayTimestamps()

  const debounceKeywordUpdate = useCallback(
    debounce(() => {
      updateFilterBy()
      setKeywordDebounce(false)
    }, 300),
    [],
  )

  const updateFilterBy = () => {
    const newFilterBy = getFilterBy()
    setFilterBy(newFilterBy)
  }

  useEffect(() => {
    setKeywordDebounce(true)
    debounceKeywordUpdate()
  }, [keyword])

  useEffect(() => {
    updateFilterBy()
  }, [selectedFilter])

  useEffect(() => {
    // activity type이 인턴일 경우, activity type을 채용으로 변경하고, jobType도 intern으로 변경
    const isIntern = filterBy?.activityTypeID === String(ActivityTypeID.INTERN)
    const isCalender = filterType === 'calender'

    fetch({
      variables: {
        ...(isCalender && {
          rangeBy: {
            recruitStartAt: {
              from: timestamps.firstDay,
              to: timestamps.lastDay,
            },
            recruitCloseAt: {
              from: timestamps.firstDay,
              to: timestamps.lastDay,
            },
          },
        }),
        filterBy: {
          status: ActivityStatus.OPEN,
          ...filterBy,
          ...(isIntern && {
            jobTypes: [JobType.INTERN],
            activityTypeID: String(ActivityTypeID.RECRUIT),
          }),
        },
      },
    })
  }, [filterBy])

  return {
    count: data?.activities?.totalCount || 0,
    loading: loading || keywordDebounce,
    getFilterBy,
  }
}
